import tools from '../../tools';
import ToolbarGroup from './ToolbarGroup';

const ToolbarListMenu = () =>
  ToolbarGroup({
    menu: {
      icon: 'fa-regular fa-list-ul',
      name: 'List',
      tools: [
        [
          tools.ToolBulletedList,
          tools.ToolNumberedList,
          tools.ToolDefinitionList,
          tools.ToolCheckList,
        ],
        [tools.ToolDecreaseIndent, tools.ToolIncreaseIndent],
      ],
    },
  });
export default ToolbarListMenu;
